import { Component, OnInit } from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-popup-failure',
  templateUrl: './popup-failure.component.html',
  styleUrls: ['../popup-tadek.component.scss'],
})
export class PopupFailureComponent implements OnInit {

  constructor(private modalCtrl: ModalController) { }
  onClose_click() {
    this.modalCtrl.dismiss();
  }
  ngOnInit() {}

}
